/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { DevelopmentCenterArchiveUploadDto } from '../models';
// @ts-ignore
import type { DevelopmentCenterArchiveUploadRequestDto } from '../models';
// @ts-ignore
import type { DevelopmentCenterConfigDto } from '../models';
// @ts-ignore
import type { DevelopmentCenterFeedbackImportResultDto } from '../models';
// @ts-ignore
import type { DevelopmentCenterFeedbackMeetingRequestDto } from '../models';
// @ts-ignore
import type { DevelopmentCenterImportDto } from '../models';
// @ts-ignore
import type { DevelopmentCenterParticipantDto } from '../models';
// @ts-ignore
import type { DevelopmentCenterParticipantPageDto } from '../models';
// @ts-ignore
import type { DevelopmentCenterStageEnrolmentResultDto } from '../models';
// @ts-ignore
import type { GetDataUpdateByFileResponseDto } from '../models';
// @ts-ignore
import type { InlineObjectDto } from '../models';
/**
 * DevelopmentCenterStageApi - axios parameter creator
 * @export
 */
export const DevelopmentCenterStageApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Dopisuje do etapu DC wszystkich uczestników certyfikacji, którzy jeszcze w nim nie są. Skrót na start etapu - certyfikacja zwykle idzie na sesję w całości, a klikanie tego po jednej osobie nie miałoby sensu.  Wywołanie jest idempotentne: osoby już zapisane w etapie są pomijane, a odpowiedź mówi, ilu ludzi faktycznie doszło. 
         * @summary Add every certification participant to the Development Center stage
         * @param {number} certificationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addCertificationParticipantsToDevelopmentCenterStage: async (certificationId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'certificationId' is not null or undefined
            assertParamExists('addCertificationParticipantsToDevelopmentCenterStage', 'certificationId', certificationId)
            const localVarPath = `/api/v2/certifications/{certificationId}/development-center/participants/from-certification`
                .replace(`{${"certificationId"}}`, encodeURIComponent(String(certificationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Uruchamia rozpakowanie archiwum. Przebieg jest asynchroniczny — postęp i zgłoszone problemy odczytuje się istniejącymi endpointami uploadów, tak samo jak przy imporcie arkusza. 
         * @summary Confirm the archive upload and start unpacking
         * @param {number} certificationId 
         * @param {string} archiveId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmDevelopmentCenterReportArchive: async (certificationId: number, archiveId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'certificationId' is not null or undefined
            assertParamExists('confirmDevelopmentCenterReportArchive', 'certificationId', certificationId)
            // verify required parameter 'archiveId' is not null or undefined
            assertParamExists('confirmDevelopmentCenterReportArchive', 'archiveId', archiveId)
            const localVarPath = `/api/v2/certifications/{certificationId}/development-center/report-archive/{archiveId}/confirm`
                .replace(`{${"certificationId"}}`, encodeURIComponent(String(certificationId)))
                .replace(`{${"archiveId"}}`, encodeURIComponent(String(archiveId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Download the uploaded Development Center spreadsheet
         * @param {number} certificationId 
         * @param {string} uploadId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadDevelopmentCenterImportFile: async (certificationId: number, uploadId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'certificationId' is not null or undefined
            assertParamExists('downloadDevelopmentCenterImportFile', 'certificationId', certificationId)
            // verify required parameter 'uploadId' is not null or undefined
            assertParamExists('downloadDevelopmentCenterImportFile', 'uploadId', uploadId)
            const localVarPath = `/api/v2/certifications/{certificationId}/development-center/imports/{uploadId}/file`
                .replace(`{${"certificationId"}}`, encodeURIComponent(String(certificationId)))
                .replace(`{${"uploadId"}}`, encodeURIComponent(String(uploadId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Zwraca raport indywidualny (PDF) wskazanego uczestnika. Endpoint administracyjny - w odróżnieniu od pobierania własnego raportu przez uczestnika nie sprawdza daty udostępnienia, bo administrator musi móc sprawdzić zawartość paczki zanim raporty trafią do ludzi.  404 oznacza, że dla tej osoby nie wgrano raportu. 
         * @summary Download one participant\'s individual Development Center report
         * @param {number} certificationId 
         * @param {string} employeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadDevelopmentCenterParticipantReport: async (certificationId: number, employeeId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'certificationId' is not null or undefined
            assertParamExists('downloadDevelopmentCenterParticipantReport', 'certificationId', certificationId)
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('downloadDevelopmentCenterParticipantReport', 'employeeId', employeeId)
            const localVarPath = `/api/v2/certifications/{certificationId}/development-center/participants/{employeeId}/report`
                .replace(`{${"certificationId"}}`, encodeURIComponent(String(certificationId)))
                .replace(`{${"employeeId"}}`, encodeURIComponent(String(employeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Development Center stage configuration
         * @param {number} certificationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDevelopmentCenterConfig: async (certificationId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'certificationId' is not null or undefined
            assertParamExists('getDevelopmentCenterConfig', 'certificationId', certificationId)
            const localVarPath = `/api/v2/certifications/{certificationId}/development-center/config`
                .replace(`{${"certificationId"}}`, encodeURIComponent(String(certificationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Historia wgranych arkuszy — kto wgrał, kiedy i z jakim skutkiem.
         * @summary List Development Center result imports for a certification
         * @param {number} certificationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDevelopmentCenterImports: async (certificationId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'certificationId' is not null or undefined
            assertParamExists('getDevelopmentCenterImports', 'certificationId', certificationId)
            const localVarPath = `/api/v2/certifications/{certificationId}/development-center/imports`
                .replace(`{${"certificationId"}}`, encodeURIComponent(String(certificationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Lista osób w etapie Development Center danej certyfikacji z informacją, czego brakuje: czy uczestnik ma wgrane wyniki ogólne (arkusz) i czy ma wgrany raport indywidualny (PDF).  Lista to suma uczestników certyfikacji i osób, dla których wgrano wynik DC — arkusz od dostawcy bywa szerszy niż lista uczestników, a takie osoby administrator musi zobaczyć. 
         * @summary List people in the Development Center stage
         * @param {number} certificationId 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [search] Fragment imienia, nazwiska albo numeru SAP.
         * @param {boolean} [hasResults] true &#x3D; tylko z wynikami, false &#x3D; tylko bez wyników, brak &#x3D; wszyscy.
         * @param {boolean} [hasReport] true &#x3D; tylko z raportem indywidualnym, false &#x3D; tylko bez raportu, brak &#x3D; wszyscy.
         * @param {boolean} [hasFeedbackMeeting] true &#x3D; tylko po spotkaniu feedbackowym DC, false &#x3D; tylko przed nim, brak &#x3D; wszyscy.
         * @param {Array<string>} [regionCodes] Kody regionu pracownika (&#x60;dict_region.code&#x60;, np. &#x60;R17&#x60;, &#x60;HQ&#x60;). Wiele wartości (CSV) łączy się przez OR, z pozostałymi filtrami przez AND; brak &#x3D; wszystkie regiony.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDevelopmentCenterParticipants: async (certificationId: number, page?: number, pageSize?: number, search?: string, hasResults?: boolean, hasReport?: boolean, hasFeedbackMeeting?: boolean, regionCodes?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'certificationId' is not null or undefined
            assertParamExists('getDevelopmentCenterParticipants', 'certificationId', certificationId)
            const localVarPath = `/api/v2/certifications/{certificationId}/development-center/participants`
                .replace(`{${"certificationId"}}`, encodeURIComponent(String(certificationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (hasResults !== undefined) {
                localVarQueryParameter['hasResults'] = hasResults;
            }

            if (hasReport !== undefined) {
                localVarQueryParameter['hasReport'] = hasReport;
            }

            if (hasFeedbackMeeting !== undefined) {
                localVarQueryParameter['hasFeedbackMeeting'] = hasFeedbackMeeting;
            }

            if (regionCodes) {
                localVarQueryParameter['regionCodes'] = regionCodes.join(COLLECTION_FORMATS.csv);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Wgranie pliku z numerami SAP i informacją, czy spotkanie feedbackowe po sesji Development Center się odbyło. Ustawia dokładnie to samo, co checkbox na liście osób w etapie - plik jest wyłącznie szybszą drogą dla większej liczby osób.  Import jest synchroniczny: odpowiedź niesie od razu podsumowanie i listę problemów.  Jeden błędny wiersz nie blokuje pliku - poprawne wiersze zostają zapisane, a reszta trafia do `problems` z numerem wiersza i numerem SAP. 400 zwracamy tylko wtedy, gdy pliku nie da się odczytać albo brakuje w nim wymaganych kolumn, czyli gdy nie ma czego importować. 
         * @summary Import post-DC feedback meetings from a spreadsheet
         * @param {number} certificationId 
         * @param {File} file Arkusz z kolumnami \\\&quot;nr sap\\\&quot; i \\\&quot;feedback\\\&quot;.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importDevelopmentCenterFeedbackMeetings: async (certificationId: number, file: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'certificationId' is not null or undefined
            assertParamExists('importDevelopmentCenterFeedbackMeetings', 'certificationId', certificationId)
            // verify required parameter 'file' is not null or undefined
            assertParamExists('importDevelopmentCenterFeedbackMeetings', 'file', file)
            const localVarPath = `/api/v2/certifications/{certificationId}/development-center/feedback-meetings/file`
                .replace(`{${"certificationId"}}`, encodeURIComponent(String(certificationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Zwraca adres, pod który przeglądarka wysyła archiwum ZIP z raportami indywidualnymi prosto do magazynu plików. Archiwum nie przechodzi przez aplikację — paczka raportów dla jednej sesji to dziesiątki megabajtów, czyli więcej, niż przyjmuje zwykły upload.  Po zakończeniu wysyłki trzeba wywołać potwierdzenie, które uruchamia rozpakowanie. 
         * @summary Request an upload URL for the individual reports archive
         * @param {number} certificationId 
         * @param {DevelopmentCenterArchiveUploadRequestDto} developmentCenterArchiveUploadRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestDevelopmentCenterReportArchiveUpload: async (certificationId: number, developmentCenterArchiveUploadRequestDto: DevelopmentCenterArchiveUploadRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'certificationId' is not null or undefined
            assertParamExists('requestDevelopmentCenterReportArchiveUpload', 'certificationId', certificationId)
            // verify required parameter 'developmentCenterArchiveUploadRequestDto' is not null or undefined
            assertParamExists('requestDevelopmentCenterReportArchiveUpload', 'developmentCenterArchiveUploadRequestDto', developmentCenterArchiveUploadRequestDto)
            const localVarPath = `/api/v2/certifications/{certificationId}/development-center/report-archive/upload-url`
                .replace(`{${"certificationId"}}`, encodeURIComponent(String(certificationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(developmentCenterArchiveUploadRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Oczekiwany poziom wyniku (skala jak w pliku od dostawcy) oraz data, od której uczestnicy widzą swoje raporty PDF. 
         * @summary Update Development Center stage configuration
         * @param {number} certificationId 
         * @param {DevelopmentCenterConfigDto} developmentCenterConfigDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDevelopmentCenterConfig: async (certificationId: number, developmentCenterConfigDto: DevelopmentCenterConfigDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'certificationId' is not null or undefined
            assertParamExists('updateDevelopmentCenterConfig', 'certificationId', certificationId)
            // verify required parameter 'developmentCenterConfigDto' is not null or undefined
            assertParamExists('updateDevelopmentCenterConfig', 'developmentCenterConfigDto', developmentCenterConfigDto)
            const localVarPath = `/api/v2/certifications/{certificationId}/development-center/config`
                .replace(`{${"certificationId"}}`, encodeURIComponent(String(certificationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(developmentCenterConfigDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Ustawia albo zdejmuje informację o odbytym spotkaniu feedbackowym po sesji Development Center. Fakt organizacyjny, którego nie ma w żadnym pliku od dostawcy - odnotowuje go administrator.  Wywołanie jest idempotentne: ustawienie tej samej wartości drugi raz nie zmienia niczego poza datą zapisu. 404 oznacza, że wskazanej osoby nie ma w etapie DC tej certyfikacji - ani wśród uczestników, ani w arkuszu wyników. 
         * @summary Record whether the participant had their post-DC feedback meeting
         * @param {number} certificationId 
         * @param {string} employeeId 
         * @param {DevelopmentCenterFeedbackMeetingRequestDto} developmentCenterFeedbackMeetingRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDevelopmentCenterFeedbackMeeting: async (certificationId: number, employeeId: string, developmentCenterFeedbackMeetingRequestDto: DevelopmentCenterFeedbackMeetingRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'certificationId' is not null or undefined
            assertParamExists('updateDevelopmentCenterFeedbackMeeting', 'certificationId', certificationId)
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('updateDevelopmentCenterFeedbackMeeting', 'employeeId', employeeId)
            // verify required parameter 'developmentCenterFeedbackMeetingRequestDto' is not null or undefined
            assertParamExists('updateDevelopmentCenterFeedbackMeeting', 'developmentCenterFeedbackMeetingRequestDto', developmentCenterFeedbackMeetingRequestDto)
            const localVarPath = `/api/v2/certifications/{certificationId}/development-center/participants/{employeeId}/feedback-meeting`
                .replace(`{${"certificationId"}}`, encodeURIComponent(String(certificationId)))
                .replace(`{${"employeeId"}}`, encodeURIComponent(String(employeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(developmentCenterFeedbackMeetingRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Wgranie arkusza z wynikami sesji Development Center dla uczestników danej certyfikacji.  Import wchodzi także wtedy, gdy część wierszy budzi wątpliwości — zgłoszone problemy (np. uczestnik nieobecny w pozostałych etapach certyfikacji) zostają zapisane jako informacja dla administratora, a nie jako powód odrzucenia pliku.  Import jest asynchroniczny: odpowiedź zwraca identyfikator uploadu, a postęp i zgłoszone problemy odczytuje się istniejącymi endpointami uploadów. 
         * @summary Upload Development Center results for a certification
         * @param {number} certificationId 
         * @param {File} file 
         * @param {number} expectedScore Oczekiwany poziom wyniku w skali pliku (1-5). Zapisywany na etapie DC, żeby wyniki uczestników dało się odnieść do progu oczekiwań.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadDevelopmentCenterResults: async (certificationId: number, file: File, expectedScore: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'certificationId' is not null or undefined
            assertParamExists('uploadDevelopmentCenterResults', 'certificationId', certificationId)
            // verify required parameter 'file' is not null or undefined
            assertParamExists('uploadDevelopmentCenterResults', 'file', file)
            // verify required parameter 'expectedScore' is not null or undefined
            assertParamExists('uploadDevelopmentCenterResults', 'expectedScore', expectedScore)
            const localVarPath = `/api/v2/certifications/{certificationId}/development-center/results`
                .replace(`{${"certificationId"}}`, encodeURIComponent(String(certificationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
            if (expectedScore !== undefined) { 
                localVarFormParams.append('expectedScore', expectedScore as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DevelopmentCenterStageApi - functional programming interface
 * @export
 */
export const DevelopmentCenterStageApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DevelopmentCenterStageApiAxiosParamCreator(configuration)
    return {
        /**
         * Dopisuje do etapu DC wszystkich uczestników certyfikacji, którzy jeszcze w nim nie są. Skrót na start etapu - certyfikacja zwykle idzie na sesję w całości, a klikanie tego po jednej osobie nie miałoby sensu.  Wywołanie jest idempotentne: osoby już zapisane w etapie są pomijane, a odpowiedź mówi, ilu ludzi faktycznie doszło. 
         * @summary Add every certification participant to the Development Center stage
         * @param {number} certificationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addCertificationParticipantsToDevelopmentCenterStage(certificationId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DevelopmentCenterStageEnrolmentResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addCertificationParticipantsToDevelopmentCenterStage(certificationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DevelopmentCenterStageApi.addCertificationParticipantsToDevelopmentCenterStage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Uruchamia rozpakowanie archiwum. Przebieg jest asynchroniczny — postęp i zgłoszone problemy odczytuje się istniejącymi endpointami uploadów, tak samo jak przy imporcie arkusza. 
         * @summary Confirm the archive upload and start unpacking
         * @param {number} certificationId 
         * @param {string} archiveId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async confirmDevelopmentCenterReportArchive(certificationId: number, archiveId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetDataUpdateByFileResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.confirmDevelopmentCenterReportArchive(certificationId, archiveId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DevelopmentCenterStageApi.confirmDevelopmentCenterReportArchive']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Download the uploaded Development Center spreadsheet
         * @param {number} certificationId 
         * @param {string} uploadId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadDevelopmentCenterImportFile(certificationId: number, uploadId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadDevelopmentCenterImportFile(certificationId, uploadId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DevelopmentCenterStageApi.downloadDevelopmentCenterImportFile']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Zwraca raport indywidualny (PDF) wskazanego uczestnika. Endpoint administracyjny - w odróżnieniu od pobierania własnego raportu przez uczestnika nie sprawdza daty udostępnienia, bo administrator musi móc sprawdzić zawartość paczki zanim raporty trafią do ludzi.  404 oznacza, że dla tej osoby nie wgrano raportu. 
         * @summary Download one participant\'s individual Development Center report
         * @param {number} certificationId 
         * @param {string} employeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadDevelopmentCenterParticipantReport(certificationId: number, employeeId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadDevelopmentCenterParticipantReport(certificationId, employeeId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DevelopmentCenterStageApi.downloadDevelopmentCenterParticipantReport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Development Center stage configuration
         * @param {number} certificationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDevelopmentCenterConfig(certificationId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DevelopmentCenterConfigDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDevelopmentCenterConfig(certificationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DevelopmentCenterStageApi.getDevelopmentCenterConfig']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Historia wgranych arkuszy — kto wgrał, kiedy i z jakim skutkiem.
         * @summary List Development Center result imports for a certification
         * @param {number} certificationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDevelopmentCenterImports(certificationId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DevelopmentCenterImportDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDevelopmentCenterImports(certificationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DevelopmentCenterStageApi.getDevelopmentCenterImports']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Lista osób w etapie Development Center danej certyfikacji z informacją, czego brakuje: czy uczestnik ma wgrane wyniki ogólne (arkusz) i czy ma wgrany raport indywidualny (PDF).  Lista to suma uczestników certyfikacji i osób, dla których wgrano wynik DC — arkusz od dostawcy bywa szerszy niż lista uczestników, a takie osoby administrator musi zobaczyć. 
         * @summary List people in the Development Center stage
         * @param {number} certificationId 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [search] Fragment imienia, nazwiska albo numeru SAP.
         * @param {boolean} [hasResults] true &#x3D; tylko z wynikami, false &#x3D; tylko bez wyników, brak &#x3D; wszyscy.
         * @param {boolean} [hasReport] true &#x3D; tylko z raportem indywidualnym, false &#x3D; tylko bez raportu, brak &#x3D; wszyscy.
         * @param {boolean} [hasFeedbackMeeting] true &#x3D; tylko po spotkaniu feedbackowym DC, false &#x3D; tylko przed nim, brak &#x3D; wszyscy.
         * @param {Array<string>} [regionCodes] Kody regionu pracownika (&#x60;dict_region.code&#x60;, np. &#x60;R17&#x60;, &#x60;HQ&#x60;). Wiele wartości (CSV) łączy się przez OR, z pozostałymi filtrami przez AND; brak &#x3D; wszystkie regiony.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDevelopmentCenterParticipants(certificationId: number, page?: number, pageSize?: number, search?: string, hasResults?: boolean, hasReport?: boolean, hasFeedbackMeeting?: boolean, regionCodes?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DevelopmentCenterParticipantPageDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDevelopmentCenterParticipants(certificationId, page, pageSize, search, hasResults, hasReport, hasFeedbackMeeting, regionCodes, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DevelopmentCenterStageApi.getDevelopmentCenterParticipants']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Wgranie pliku z numerami SAP i informacją, czy spotkanie feedbackowe po sesji Development Center się odbyło. Ustawia dokładnie to samo, co checkbox na liście osób w etapie - plik jest wyłącznie szybszą drogą dla większej liczby osób.  Import jest synchroniczny: odpowiedź niesie od razu podsumowanie i listę problemów.  Jeden błędny wiersz nie blokuje pliku - poprawne wiersze zostają zapisane, a reszta trafia do `problems` z numerem wiersza i numerem SAP. 400 zwracamy tylko wtedy, gdy pliku nie da się odczytać albo brakuje w nim wymaganych kolumn, czyli gdy nie ma czego importować. 
         * @summary Import post-DC feedback meetings from a spreadsheet
         * @param {number} certificationId 
         * @param {File} file Arkusz z kolumnami \\\&quot;nr sap\\\&quot; i \\\&quot;feedback\\\&quot;.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async importDevelopmentCenterFeedbackMeetings(certificationId: number, file: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DevelopmentCenterFeedbackImportResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.importDevelopmentCenterFeedbackMeetings(certificationId, file, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DevelopmentCenterStageApi.importDevelopmentCenterFeedbackMeetings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Zwraca adres, pod który przeglądarka wysyła archiwum ZIP z raportami indywidualnymi prosto do magazynu plików. Archiwum nie przechodzi przez aplikację — paczka raportów dla jednej sesji to dziesiątki megabajtów, czyli więcej, niż przyjmuje zwykły upload.  Po zakończeniu wysyłki trzeba wywołać potwierdzenie, które uruchamia rozpakowanie. 
         * @summary Request an upload URL for the individual reports archive
         * @param {number} certificationId 
         * @param {DevelopmentCenterArchiveUploadRequestDto} developmentCenterArchiveUploadRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async requestDevelopmentCenterReportArchiveUpload(certificationId: number, developmentCenterArchiveUploadRequestDto: DevelopmentCenterArchiveUploadRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DevelopmentCenterArchiveUploadDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.requestDevelopmentCenterReportArchiveUpload(certificationId, developmentCenterArchiveUploadRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DevelopmentCenterStageApi.requestDevelopmentCenterReportArchiveUpload']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Oczekiwany poziom wyniku (skala jak w pliku od dostawcy) oraz data, od której uczestnicy widzą swoje raporty PDF. 
         * @summary Update Development Center stage configuration
         * @param {number} certificationId 
         * @param {DevelopmentCenterConfigDto} developmentCenterConfigDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateDevelopmentCenterConfig(certificationId: number, developmentCenterConfigDto: DevelopmentCenterConfigDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DevelopmentCenterConfigDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateDevelopmentCenterConfig(certificationId, developmentCenterConfigDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DevelopmentCenterStageApi.updateDevelopmentCenterConfig']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Ustawia albo zdejmuje informację o odbytym spotkaniu feedbackowym po sesji Development Center. Fakt organizacyjny, którego nie ma w żadnym pliku od dostawcy - odnotowuje go administrator.  Wywołanie jest idempotentne: ustawienie tej samej wartości drugi raz nie zmienia niczego poza datą zapisu. 404 oznacza, że wskazanej osoby nie ma w etapie DC tej certyfikacji - ani wśród uczestników, ani w arkuszu wyników. 
         * @summary Record whether the participant had their post-DC feedback meeting
         * @param {number} certificationId 
         * @param {string} employeeId 
         * @param {DevelopmentCenterFeedbackMeetingRequestDto} developmentCenterFeedbackMeetingRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateDevelopmentCenterFeedbackMeeting(certificationId: number, employeeId: string, developmentCenterFeedbackMeetingRequestDto: DevelopmentCenterFeedbackMeetingRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DevelopmentCenterParticipantDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateDevelopmentCenterFeedbackMeeting(certificationId, employeeId, developmentCenterFeedbackMeetingRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DevelopmentCenterStageApi.updateDevelopmentCenterFeedbackMeeting']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Wgranie arkusza z wynikami sesji Development Center dla uczestników danej certyfikacji.  Import wchodzi także wtedy, gdy część wierszy budzi wątpliwości — zgłoszone problemy (np. uczestnik nieobecny w pozostałych etapach certyfikacji) zostają zapisane jako informacja dla administratora, a nie jako powód odrzucenia pliku.  Import jest asynchroniczny: odpowiedź zwraca identyfikator uploadu, a postęp i zgłoszone problemy odczytuje się istniejącymi endpointami uploadów. 
         * @summary Upload Development Center results for a certification
         * @param {number} certificationId 
         * @param {File} file 
         * @param {number} expectedScore Oczekiwany poziom wyniku w skali pliku (1-5). Zapisywany na etapie DC, żeby wyniki uczestników dało się odnieść do progu oczekiwań.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadDevelopmentCenterResults(certificationId: number, file: File, expectedScore: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetDataUpdateByFileResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadDevelopmentCenterResults(certificationId, file, expectedScore, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DevelopmentCenterStageApi.uploadDevelopmentCenterResults']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DevelopmentCenterStageApi - factory interface
 * @export
 */
export const DevelopmentCenterStageApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DevelopmentCenterStageApiFp(configuration)
    return {
        /**
         * Dopisuje do etapu DC wszystkich uczestników certyfikacji, którzy jeszcze w nim nie są. Skrót na start etapu - certyfikacja zwykle idzie na sesję w całości, a klikanie tego po jednej osobie nie miałoby sensu.  Wywołanie jest idempotentne: osoby już zapisane w etapie są pomijane, a odpowiedź mówi, ilu ludzi faktycznie doszło. 
         * @summary Add every certification participant to the Development Center stage
         * @param {number} certificationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addCertificationParticipantsToDevelopmentCenterStage(certificationId: number, options?: RawAxiosRequestConfig): AxiosPromise<DevelopmentCenterStageEnrolmentResultDto> {
            return localVarFp.addCertificationParticipantsToDevelopmentCenterStage(certificationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Uruchamia rozpakowanie archiwum. Przebieg jest asynchroniczny — postęp i zgłoszone problemy odczytuje się istniejącymi endpointami uploadów, tak samo jak przy imporcie arkusza. 
         * @summary Confirm the archive upload and start unpacking
         * @param {number} certificationId 
         * @param {string} archiveId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmDevelopmentCenterReportArchive(certificationId: number, archiveId: string, options?: RawAxiosRequestConfig): AxiosPromise<GetDataUpdateByFileResponseDto> {
            return localVarFp.confirmDevelopmentCenterReportArchive(certificationId, archiveId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Download the uploaded Development Center spreadsheet
         * @param {number} certificationId 
         * @param {string} uploadId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadDevelopmentCenterImportFile(certificationId: number, uploadId: string, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.downloadDevelopmentCenterImportFile(certificationId, uploadId, options).then((request) => request(axios, basePath));
        },
        /**
         * Zwraca raport indywidualny (PDF) wskazanego uczestnika. Endpoint administracyjny - w odróżnieniu od pobierania własnego raportu przez uczestnika nie sprawdza daty udostępnienia, bo administrator musi móc sprawdzić zawartość paczki zanim raporty trafią do ludzi.  404 oznacza, że dla tej osoby nie wgrano raportu. 
         * @summary Download one participant\'s individual Development Center report
         * @param {number} certificationId 
         * @param {string} employeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadDevelopmentCenterParticipantReport(certificationId: number, employeeId: string, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.downloadDevelopmentCenterParticipantReport(certificationId, employeeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Development Center stage configuration
         * @param {number} certificationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDevelopmentCenterConfig(certificationId: number, options?: RawAxiosRequestConfig): AxiosPromise<DevelopmentCenterConfigDto> {
            return localVarFp.getDevelopmentCenterConfig(certificationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Historia wgranych arkuszy — kto wgrał, kiedy i z jakim skutkiem.
         * @summary List Development Center result imports for a certification
         * @param {number} certificationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDevelopmentCenterImports(certificationId: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<DevelopmentCenterImportDto>> {
            return localVarFp.getDevelopmentCenterImports(certificationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Lista osób w etapie Development Center danej certyfikacji z informacją, czego brakuje: czy uczestnik ma wgrane wyniki ogólne (arkusz) i czy ma wgrany raport indywidualny (PDF).  Lista to suma uczestników certyfikacji i osób, dla których wgrano wynik DC — arkusz od dostawcy bywa szerszy niż lista uczestników, a takie osoby administrator musi zobaczyć. 
         * @summary List people in the Development Center stage
         * @param {number} certificationId 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [search] Fragment imienia, nazwiska albo numeru SAP.
         * @param {boolean} [hasResults] true &#x3D; tylko z wynikami, false &#x3D; tylko bez wyników, brak &#x3D; wszyscy.
         * @param {boolean} [hasReport] true &#x3D; tylko z raportem indywidualnym, false &#x3D; tylko bez raportu, brak &#x3D; wszyscy.
         * @param {boolean} [hasFeedbackMeeting] true &#x3D; tylko po spotkaniu feedbackowym DC, false &#x3D; tylko przed nim, brak &#x3D; wszyscy.
         * @param {Array<string>} [regionCodes] Kody regionu pracownika (&#x60;dict_region.code&#x60;, np. &#x60;R17&#x60;, &#x60;HQ&#x60;). Wiele wartości (CSV) łączy się przez OR, z pozostałymi filtrami przez AND; brak &#x3D; wszystkie regiony.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDevelopmentCenterParticipants(certificationId: number, page?: number, pageSize?: number, search?: string, hasResults?: boolean, hasReport?: boolean, hasFeedbackMeeting?: boolean, regionCodes?: Array<string>, options?: RawAxiosRequestConfig): AxiosPromise<DevelopmentCenterParticipantPageDto> {
            return localVarFp.getDevelopmentCenterParticipants(certificationId, page, pageSize, search, hasResults, hasReport, hasFeedbackMeeting, regionCodes, options).then((request) => request(axios, basePath));
        },
        /**
         * Wgranie pliku z numerami SAP i informacją, czy spotkanie feedbackowe po sesji Development Center się odbyło. Ustawia dokładnie to samo, co checkbox na liście osób w etapie - plik jest wyłącznie szybszą drogą dla większej liczby osób.  Import jest synchroniczny: odpowiedź niesie od razu podsumowanie i listę problemów.  Jeden błędny wiersz nie blokuje pliku - poprawne wiersze zostają zapisane, a reszta trafia do `problems` z numerem wiersza i numerem SAP. 400 zwracamy tylko wtedy, gdy pliku nie da się odczytać albo brakuje w nim wymaganych kolumn, czyli gdy nie ma czego importować. 
         * @summary Import post-DC feedback meetings from a spreadsheet
         * @param {number} certificationId 
         * @param {File} file Arkusz z kolumnami \\\&quot;nr sap\\\&quot; i \\\&quot;feedback\\\&quot;.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importDevelopmentCenterFeedbackMeetings(certificationId: number, file: File, options?: RawAxiosRequestConfig): AxiosPromise<DevelopmentCenterFeedbackImportResultDto> {
            return localVarFp.importDevelopmentCenterFeedbackMeetings(certificationId, file, options).then((request) => request(axios, basePath));
        },
        /**
         * Zwraca adres, pod który przeglądarka wysyła archiwum ZIP z raportami indywidualnymi prosto do magazynu plików. Archiwum nie przechodzi przez aplikację — paczka raportów dla jednej sesji to dziesiątki megabajtów, czyli więcej, niż przyjmuje zwykły upload.  Po zakończeniu wysyłki trzeba wywołać potwierdzenie, które uruchamia rozpakowanie. 
         * @summary Request an upload URL for the individual reports archive
         * @param {number} certificationId 
         * @param {DevelopmentCenterArchiveUploadRequestDto} developmentCenterArchiveUploadRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestDevelopmentCenterReportArchiveUpload(certificationId: number, developmentCenterArchiveUploadRequestDto: DevelopmentCenterArchiveUploadRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<DevelopmentCenterArchiveUploadDto> {
            return localVarFp.requestDevelopmentCenterReportArchiveUpload(certificationId, developmentCenterArchiveUploadRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Oczekiwany poziom wyniku (skala jak w pliku od dostawcy) oraz data, od której uczestnicy widzą swoje raporty PDF. 
         * @summary Update Development Center stage configuration
         * @param {number} certificationId 
         * @param {DevelopmentCenterConfigDto} developmentCenterConfigDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDevelopmentCenterConfig(certificationId: number, developmentCenterConfigDto: DevelopmentCenterConfigDto, options?: RawAxiosRequestConfig): AxiosPromise<DevelopmentCenterConfigDto> {
            return localVarFp.updateDevelopmentCenterConfig(certificationId, developmentCenterConfigDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Ustawia albo zdejmuje informację o odbytym spotkaniu feedbackowym po sesji Development Center. Fakt organizacyjny, którego nie ma w żadnym pliku od dostawcy - odnotowuje go administrator.  Wywołanie jest idempotentne: ustawienie tej samej wartości drugi raz nie zmienia niczego poza datą zapisu. 404 oznacza, że wskazanej osoby nie ma w etapie DC tej certyfikacji - ani wśród uczestników, ani w arkuszu wyników. 
         * @summary Record whether the participant had their post-DC feedback meeting
         * @param {number} certificationId 
         * @param {string} employeeId 
         * @param {DevelopmentCenterFeedbackMeetingRequestDto} developmentCenterFeedbackMeetingRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDevelopmentCenterFeedbackMeeting(certificationId: number, employeeId: string, developmentCenterFeedbackMeetingRequestDto: DevelopmentCenterFeedbackMeetingRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<DevelopmentCenterParticipantDto> {
            return localVarFp.updateDevelopmentCenterFeedbackMeeting(certificationId, employeeId, developmentCenterFeedbackMeetingRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Wgranie arkusza z wynikami sesji Development Center dla uczestników danej certyfikacji.  Import wchodzi także wtedy, gdy część wierszy budzi wątpliwości — zgłoszone problemy (np. uczestnik nieobecny w pozostałych etapach certyfikacji) zostają zapisane jako informacja dla administratora, a nie jako powód odrzucenia pliku.  Import jest asynchroniczny: odpowiedź zwraca identyfikator uploadu, a postęp i zgłoszone problemy odczytuje się istniejącymi endpointami uploadów. 
         * @summary Upload Development Center results for a certification
         * @param {number} certificationId 
         * @param {File} file 
         * @param {number} expectedScore Oczekiwany poziom wyniku w skali pliku (1-5). Zapisywany na etapie DC, żeby wyniki uczestników dało się odnieść do progu oczekiwań.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadDevelopmentCenterResults(certificationId: number, file: File, expectedScore: number, options?: RawAxiosRequestConfig): AxiosPromise<GetDataUpdateByFileResponseDto> {
            return localVarFp.uploadDevelopmentCenterResults(certificationId, file, expectedScore, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DevelopmentCenterStageApi - interface
 * @export
 * @interface DevelopmentCenterStageApi
 */
export interface DevelopmentCenterStageApiInterface {
    /**
     * Dopisuje do etapu DC wszystkich uczestników certyfikacji, którzy jeszcze w nim nie są. Skrót na start etapu - certyfikacja zwykle idzie na sesję w całości, a klikanie tego po jednej osobie nie miałoby sensu.  Wywołanie jest idempotentne: osoby już zapisane w etapie są pomijane, a odpowiedź mówi, ilu ludzi faktycznie doszło. 
     * @summary Add every certification participant to the Development Center stage
     * @param {number} certificationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DevelopmentCenterStageApiInterface
     */
    addCertificationParticipantsToDevelopmentCenterStage(certificationId: number, options?: RawAxiosRequestConfig): AxiosPromise<DevelopmentCenterStageEnrolmentResultDto>;

    /**
     * Uruchamia rozpakowanie archiwum. Przebieg jest asynchroniczny — postęp i zgłoszone problemy odczytuje się istniejącymi endpointami uploadów, tak samo jak przy imporcie arkusza. 
     * @summary Confirm the archive upload and start unpacking
     * @param {number} certificationId 
     * @param {string} archiveId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DevelopmentCenterStageApiInterface
     */
    confirmDevelopmentCenterReportArchive(certificationId: number, archiveId: string, options?: RawAxiosRequestConfig): AxiosPromise<GetDataUpdateByFileResponseDto>;

    /**
     * 
     * @summary Download the uploaded Development Center spreadsheet
     * @param {number} certificationId 
     * @param {string} uploadId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DevelopmentCenterStageApiInterface
     */
    downloadDevelopmentCenterImportFile(certificationId: number, uploadId: string, options?: RawAxiosRequestConfig): AxiosPromise<File>;

    /**
     * Zwraca raport indywidualny (PDF) wskazanego uczestnika. Endpoint administracyjny - w odróżnieniu od pobierania własnego raportu przez uczestnika nie sprawdza daty udostępnienia, bo administrator musi móc sprawdzić zawartość paczki zanim raporty trafią do ludzi.  404 oznacza, że dla tej osoby nie wgrano raportu. 
     * @summary Download one participant\'s individual Development Center report
     * @param {number} certificationId 
     * @param {string} employeeId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DevelopmentCenterStageApiInterface
     */
    downloadDevelopmentCenterParticipantReport(certificationId: number, employeeId: string, options?: RawAxiosRequestConfig): AxiosPromise<File>;

    /**
     * 
     * @summary Get Development Center stage configuration
     * @param {number} certificationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DevelopmentCenterStageApiInterface
     */
    getDevelopmentCenterConfig(certificationId: number, options?: RawAxiosRequestConfig): AxiosPromise<DevelopmentCenterConfigDto>;

    /**
     * Historia wgranych arkuszy — kto wgrał, kiedy i z jakim skutkiem.
     * @summary List Development Center result imports for a certification
     * @param {number} certificationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DevelopmentCenterStageApiInterface
     */
    getDevelopmentCenterImports(certificationId: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<DevelopmentCenterImportDto>>;

    /**
     * Lista osób w etapie Development Center danej certyfikacji z informacją, czego brakuje: czy uczestnik ma wgrane wyniki ogólne (arkusz) i czy ma wgrany raport indywidualny (PDF).  Lista to suma uczestników certyfikacji i osób, dla których wgrano wynik DC — arkusz od dostawcy bywa szerszy niż lista uczestników, a takie osoby administrator musi zobaczyć. 
     * @summary List people in the Development Center stage
     * @param {number} certificationId 
     * @param {number} [page] 
     * @param {number} [pageSize] 
     * @param {string} [search] Fragment imienia, nazwiska albo numeru SAP.
     * @param {boolean} [hasResults] true &#x3D; tylko z wynikami, false &#x3D; tylko bez wyników, brak &#x3D; wszyscy.
     * @param {boolean} [hasReport] true &#x3D; tylko z raportem indywidualnym, false &#x3D; tylko bez raportu, brak &#x3D; wszyscy.
     * @param {boolean} [hasFeedbackMeeting] true &#x3D; tylko po spotkaniu feedbackowym DC, false &#x3D; tylko przed nim, brak &#x3D; wszyscy.
     * @param {Array<string>} [regionCodes] Kody regionu pracownika (&#x60;dict_region.code&#x60;, np. &#x60;R17&#x60;, &#x60;HQ&#x60;). Wiele wartości (CSV) łączy się przez OR, z pozostałymi filtrami przez AND; brak &#x3D; wszystkie regiony.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DevelopmentCenterStageApiInterface
     */
    getDevelopmentCenterParticipants(certificationId: number, page?: number, pageSize?: number, search?: string, hasResults?: boolean, hasReport?: boolean, hasFeedbackMeeting?: boolean, regionCodes?: Array<string>, options?: RawAxiosRequestConfig): AxiosPromise<DevelopmentCenterParticipantPageDto>;

    /**
     * Wgranie pliku z numerami SAP i informacją, czy spotkanie feedbackowe po sesji Development Center się odbyło. Ustawia dokładnie to samo, co checkbox na liście osób w etapie - plik jest wyłącznie szybszą drogą dla większej liczby osób.  Import jest synchroniczny: odpowiedź niesie od razu podsumowanie i listę problemów.  Jeden błędny wiersz nie blokuje pliku - poprawne wiersze zostają zapisane, a reszta trafia do `problems` z numerem wiersza i numerem SAP. 400 zwracamy tylko wtedy, gdy pliku nie da się odczytać albo brakuje w nim wymaganych kolumn, czyli gdy nie ma czego importować. 
     * @summary Import post-DC feedback meetings from a spreadsheet
     * @param {number} certificationId 
     * @param {File} file Arkusz z kolumnami \\\&quot;nr sap\\\&quot; i \\\&quot;feedback\\\&quot;.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DevelopmentCenterStageApiInterface
     */
    importDevelopmentCenterFeedbackMeetings(certificationId: number, file: File, options?: RawAxiosRequestConfig): AxiosPromise<DevelopmentCenterFeedbackImportResultDto>;

    /**
     * Zwraca adres, pod który przeglądarka wysyła archiwum ZIP z raportami indywidualnymi prosto do magazynu plików. Archiwum nie przechodzi przez aplikację — paczka raportów dla jednej sesji to dziesiątki megabajtów, czyli więcej, niż przyjmuje zwykły upload.  Po zakończeniu wysyłki trzeba wywołać potwierdzenie, które uruchamia rozpakowanie. 
     * @summary Request an upload URL for the individual reports archive
     * @param {number} certificationId 
     * @param {DevelopmentCenterArchiveUploadRequestDto} developmentCenterArchiveUploadRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DevelopmentCenterStageApiInterface
     */
    requestDevelopmentCenterReportArchiveUpload(certificationId: number, developmentCenterArchiveUploadRequestDto: DevelopmentCenterArchiveUploadRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<DevelopmentCenterArchiveUploadDto>;

    /**
     * Oczekiwany poziom wyniku (skala jak w pliku od dostawcy) oraz data, od której uczestnicy widzą swoje raporty PDF. 
     * @summary Update Development Center stage configuration
     * @param {number} certificationId 
     * @param {DevelopmentCenterConfigDto} developmentCenterConfigDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DevelopmentCenterStageApiInterface
     */
    updateDevelopmentCenterConfig(certificationId: number, developmentCenterConfigDto: DevelopmentCenterConfigDto, options?: RawAxiosRequestConfig): AxiosPromise<DevelopmentCenterConfigDto>;

    /**
     * Ustawia albo zdejmuje informację o odbytym spotkaniu feedbackowym po sesji Development Center. Fakt organizacyjny, którego nie ma w żadnym pliku od dostawcy - odnotowuje go administrator.  Wywołanie jest idempotentne: ustawienie tej samej wartości drugi raz nie zmienia niczego poza datą zapisu. 404 oznacza, że wskazanej osoby nie ma w etapie DC tej certyfikacji - ani wśród uczestników, ani w arkuszu wyników. 
     * @summary Record whether the participant had their post-DC feedback meeting
     * @param {number} certificationId 
     * @param {string} employeeId 
     * @param {DevelopmentCenterFeedbackMeetingRequestDto} developmentCenterFeedbackMeetingRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DevelopmentCenterStageApiInterface
     */
    updateDevelopmentCenterFeedbackMeeting(certificationId: number, employeeId: string, developmentCenterFeedbackMeetingRequestDto: DevelopmentCenterFeedbackMeetingRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<DevelopmentCenterParticipantDto>;

    /**
     * Wgranie arkusza z wynikami sesji Development Center dla uczestników danej certyfikacji.  Import wchodzi także wtedy, gdy część wierszy budzi wątpliwości — zgłoszone problemy (np. uczestnik nieobecny w pozostałych etapach certyfikacji) zostają zapisane jako informacja dla administratora, a nie jako powód odrzucenia pliku.  Import jest asynchroniczny: odpowiedź zwraca identyfikator uploadu, a postęp i zgłoszone problemy odczytuje się istniejącymi endpointami uploadów. 
     * @summary Upload Development Center results for a certification
     * @param {number} certificationId 
     * @param {File} file 
     * @param {number} expectedScore Oczekiwany poziom wyniku w skali pliku (1-5). Zapisywany na etapie DC, żeby wyniki uczestników dało się odnieść do progu oczekiwań.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DevelopmentCenterStageApiInterface
     */
    uploadDevelopmentCenterResults(certificationId: number, file: File, expectedScore: number, options?: RawAxiosRequestConfig): AxiosPromise<GetDataUpdateByFileResponseDto>;

}

/**
 * DevelopmentCenterStageApi - object-oriented interface
 * @export
 * @class DevelopmentCenterStageApi
 * @extends {BaseAPI}
 */
export class DevelopmentCenterStageApi extends BaseAPI implements DevelopmentCenterStageApiInterface {
    /**
     * Dopisuje do etapu DC wszystkich uczestników certyfikacji, którzy jeszcze w nim nie są. Skrót na start etapu - certyfikacja zwykle idzie na sesję w całości, a klikanie tego po jednej osobie nie miałoby sensu.  Wywołanie jest idempotentne: osoby już zapisane w etapie są pomijane, a odpowiedź mówi, ilu ludzi faktycznie doszło. 
     * @summary Add every certification participant to the Development Center stage
     * @param {number} certificationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DevelopmentCenterStageApi
     */
    public addCertificationParticipantsToDevelopmentCenterStage(certificationId: number, options?: RawAxiosRequestConfig) {
        return DevelopmentCenterStageApiFp(this.configuration).addCertificationParticipantsToDevelopmentCenterStage(certificationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Uruchamia rozpakowanie archiwum. Przebieg jest asynchroniczny — postęp i zgłoszone problemy odczytuje się istniejącymi endpointami uploadów, tak samo jak przy imporcie arkusza. 
     * @summary Confirm the archive upload and start unpacking
     * @param {number} certificationId 
     * @param {string} archiveId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DevelopmentCenterStageApi
     */
    public confirmDevelopmentCenterReportArchive(certificationId: number, archiveId: string, options?: RawAxiosRequestConfig) {
        return DevelopmentCenterStageApiFp(this.configuration).confirmDevelopmentCenterReportArchive(certificationId, archiveId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Download the uploaded Development Center spreadsheet
     * @param {number} certificationId 
     * @param {string} uploadId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DevelopmentCenterStageApi
     */
    public downloadDevelopmentCenterImportFile(certificationId: number, uploadId: string, options?: RawAxiosRequestConfig) {
        return DevelopmentCenterStageApiFp(this.configuration).downloadDevelopmentCenterImportFile(certificationId, uploadId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Zwraca raport indywidualny (PDF) wskazanego uczestnika. Endpoint administracyjny - w odróżnieniu od pobierania własnego raportu przez uczestnika nie sprawdza daty udostępnienia, bo administrator musi móc sprawdzić zawartość paczki zanim raporty trafią do ludzi.  404 oznacza, że dla tej osoby nie wgrano raportu. 
     * @summary Download one participant\'s individual Development Center report
     * @param {number} certificationId 
     * @param {string} employeeId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DevelopmentCenterStageApi
     */
    public downloadDevelopmentCenterParticipantReport(certificationId: number, employeeId: string, options?: RawAxiosRequestConfig) {
        return DevelopmentCenterStageApiFp(this.configuration).downloadDevelopmentCenterParticipantReport(certificationId, employeeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Development Center stage configuration
     * @param {number} certificationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DevelopmentCenterStageApi
     */
    public getDevelopmentCenterConfig(certificationId: number, options?: RawAxiosRequestConfig) {
        return DevelopmentCenterStageApiFp(this.configuration).getDevelopmentCenterConfig(certificationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Historia wgranych arkuszy — kto wgrał, kiedy i z jakim skutkiem.
     * @summary List Development Center result imports for a certification
     * @param {number} certificationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DevelopmentCenterStageApi
     */
    public getDevelopmentCenterImports(certificationId: number, options?: RawAxiosRequestConfig) {
        return DevelopmentCenterStageApiFp(this.configuration).getDevelopmentCenterImports(certificationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Lista osób w etapie Development Center danej certyfikacji z informacją, czego brakuje: czy uczestnik ma wgrane wyniki ogólne (arkusz) i czy ma wgrany raport indywidualny (PDF).  Lista to suma uczestników certyfikacji i osób, dla których wgrano wynik DC — arkusz od dostawcy bywa szerszy niż lista uczestników, a takie osoby administrator musi zobaczyć. 
     * @summary List people in the Development Center stage
     * @param {number} certificationId 
     * @param {number} [page] 
     * @param {number} [pageSize] 
     * @param {string} [search] Fragment imienia, nazwiska albo numeru SAP.
     * @param {boolean} [hasResults] true &#x3D; tylko z wynikami, false &#x3D; tylko bez wyników, brak &#x3D; wszyscy.
     * @param {boolean} [hasReport] true &#x3D; tylko z raportem indywidualnym, false &#x3D; tylko bez raportu, brak &#x3D; wszyscy.
     * @param {boolean} [hasFeedbackMeeting] true &#x3D; tylko po spotkaniu feedbackowym DC, false &#x3D; tylko przed nim, brak &#x3D; wszyscy.
     * @param {Array<string>} [regionCodes] Kody regionu pracownika (&#x60;dict_region.code&#x60;, np. &#x60;R17&#x60;, &#x60;HQ&#x60;). Wiele wartości (CSV) łączy się przez OR, z pozostałymi filtrami przez AND; brak &#x3D; wszystkie regiony.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DevelopmentCenterStageApi
     */
    public getDevelopmentCenterParticipants(certificationId: number, page?: number, pageSize?: number, search?: string, hasResults?: boolean, hasReport?: boolean, hasFeedbackMeeting?: boolean, regionCodes?: Array<string>, options?: RawAxiosRequestConfig) {
        return DevelopmentCenterStageApiFp(this.configuration).getDevelopmentCenterParticipants(certificationId, page, pageSize, search, hasResults, hasReport, hasFeedbackMeeting, regionCodes, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Wgranie pliku z numerami SAP i informacją, czy spotkanie feedbackowe po sesji Development Center się odbyło. Ustawia dokładnie to samo, co checkbox na liście osób w etapie - plik jest wyłącznie szybszą drogą dla większej liczby osób.  Import jest synchroniczny: odpowiedź niesie od razu podsumowanie i listę problemów.  Jeden błędny wiersz nie blokuje pliku - poprawne wiersze zostają zapisane, a reszta trafia do `problems` z numerem wiersza i numerem SAP. 400 zwracamy tylko wtedy, gdy pliku nie da się odczytać albo brakuje w nim wymaganych kolumn, czyli gdy nie ma czego importować. 
     * @summary Import post-DC feedback meetings from a spreadsheet
     * @param {number} certificationId 
     * @param {File} file Arkusz z kolumnami \\\&quot;nr sap\\\&quot; i \\\&quot;feedback\\\&quot;.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DevelopmentCenterStageApi
     */
    public importDevelopmentCenterFeedbackMeetings(certificationId: number, file: File, options?: RawAxiosRequestConfig) {
        return DevelopmentCenterStageApiFp(this.configuration).importDevelopmentCenterFeedbackMeetings(certificationId, file, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Zwraca adres, pod który przeglądarka wysyła archiwum ZIP z raportami indywidualnymi prosto do magazynu plików. Archiwum nie przechodzi przez aplikację — paczka raportów dla jednej sesji to dziesiątki megabajtów, czyli więcej, niż przyjmuje zwykły upload.  Po zakończeniu wysyłki trzeba wywołać potwierdzenie, które uruchamia rozpakowanie. 
     * @summary Request an upload URL for the individual reports archive
     * @param {number} certificationId 
     * @param {DevelopmentCenterArchiveUploadRequestDto} developmentCenterArchiveUploadRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DevelopmentCenterStageApi
     */
    public requestDevelopmentCenterReportArchiveUpload(certificationId: number, developmentCenterArchiveUploadRequestDto: DevelopmentCenterArchiveUploadRequestDto, options?: RawAxiosRequestConfig) {
        return DevelopmentCenterStageApiFp(this.configuration).requestDevelopmentCenterReportArchiveUpload(certificationId, developmentCenterArchiveUploadRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Oczekiwany poziom wyniku (skala jak w pliku od dostawcy) oraz data, od której uczestnicy widzą swoje raporty PDF. 
     * @summary Update Development Center stage configuration
     * @param {number} certificationId 
     * @param {DevelopmentCenterConfigDto} developmentCenterConfigDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DevelopmentCenterStageApi
     */
    public updateDevelopmentCenterConfig(certificationId: number, developmentCenterConfigDto: DevelopmentCenterConfigDto, options?: RawAxiosRequestConfig) {
        return DevelopmentCenterStageApiFp(this.configuration).updateDevelopmentCenterConfig(certificationId, developmentCenterConfigDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Ustawia albo zdejmuje informację o odbytym spotkaniu feedbackowym po sesji Development Center. Fakt organizacyjny, którego nie ma w żadnym pliku od dostawcy - odnotowuje go administrator.  Wywołanie jest idempotentne: ustawienie tej samej wartości drugi raz nie zmienia niczego poza datą zapisu. 404 oznacza, że wskazanej osoby nie ma w etapie DC tej certyfikacji - ani wśród uczestników, ani w arkuszu wyników. 
     * @summary Record whether the participant had their post-DC feedback meeting
     * @param {number} certificationId 
     * @param {string} employeeId 
     * @param {DevelopmentCenterFeedbackMeetingRequestDto} developmentCenterFeedbackMeetingRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DevelopmentCenterStageApi
     */
    public updateDevelopmentCenterFeedbackMeeting(certificationId: number, employeeId: string, developmentCenterFeedbackMeetingRequestDto: DevelopmentCenterFeedbackMeetingRequestDto, options?: RawAxiosRequestConfig) {
        return DevelopmentCenterStageApiFp(this.configuration).updateDevelopmentCenterFeedbackMeeting(certificationId, employeeId, developmentCenterFeedbackMeetingRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Wgranie arkusza z wynikami sesji Development Center dla uczestników danej certyfikacji.  Import wchodzi także wtedy, gdy część wierszy budzi wątpliwości — zgłoszone problemy (np. uczestnik nieobecny w pozostałych etapach certyfikacji) zostają zapisane jako informacja dla administratora, a nie jako powód odrzucenia pliku.  Import jest asynchroniczny: odpowiedź zwraca identyfikator uploadu, a postęp i zgłoszone problemy odczytuje się istniejącymi endpointami uploadów. 
     * @summary Upload Development Center results for a certification
     * @param {number} certificationId 
     * @param {File} file 
     * @param {number} expectedScore Oczekiwany poziom wyniku w skali pliku (1-5). Zapisywany na etapie DC, żeby wyniki uczestników dało się odnieść do progu oczekiwań.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DevelopmentCenterStageApi
     */
    public uploadDevelopmentCenterResults(certificationId: number, file: File, expectedScore: number, options?: RawAxiosRequestConfig) {
        return DevelopmentCenterStageApiFp(this.configuration).uploadDevelopmentCenterResults(certificationId, file, expectedScore, options).then((request) => request(this.axios, this.basePath));
    }
}

